const subAbas = [
  { label: 'Início', rota: '/daf/home/inicio' },
  // { label: 'Números', rota: '/daf/home/numeros' },
  { label: 'Glossário', rota: '/daf/home/glossario' },
  /*{ label: 'Demandas Informações', rota: '/daf/home/demandasinformacoes' },*/
];

export default subAbas;
